export default "__VITE_ASSET__Dt2Xn22X__"